import ImageButton from './_image-button.js'
import ConfigurablePosition from './_configurable-position.js'
import FlexContainerBase from './_flex-container-base.js'
import ConfigurablePane from './_configurable-pane.js'
import ConfigurablePadding from './_configurable-padding.js'
import ConfigurableSizeBounds from './_configurable-size-bounds.js'
import Overlay from './_overlay.js'
import ScrollPane from './_scroll-pane.js'
import AbsolutePane from './_absolute-pane.js'

export default {
  name: 'SlidingPane',
  values: {
    slidingSide: 'left',
    closeButton: {
      configSet: ImageButton,
      configValues: {
        buttonIcon: {
          src: 'close',
          style: {
            minWidth: '13px',
            minHeight: '13px',
          },
        },
      },
    },
    hideCloseButton: false,
    animationDuration: '0.2s',
    isScrollable: true,
    style: {
      size: '100%',
      offset: {
        $mixin: [
          {
            configSet: ConfigurablePosition,
          },
        ],
      },
      childrenContainer: {
        position: 'relative',
        width: '100%',
        height: '100%',
        pointerEvents: 'auto',
        $mixin: [
          {
            configSet: FlexContainerBase,
          },
          {
            configSet: ConfigurablePane,
          },
        ],
      },
      $mixin: [
        {
          configSet: ConfigurablePadding,
        },
        {
          configSet: ConfigurableSizeBounds,
        },
        {
          configSet: FlexContainerBase,
        },
        {
          configSet: ConfigurablePane,
        },
      ],
    },
    overlay: {
      configSet: Overlay,
      configValues: {
        style: {
          container: {
            justifyContent: 'flex-start',
          },
        },
      },
    },
    scrollPane: {
      configSet: ScrollPane,
      configValues: {
        direction: 'y',
      },
    },
    closeButtonContainer: {
      configSet: AbsolutePane,
      configValues: {
        style: {
          top: 0,
          left: 'calc(env(safe-area-inset-left, 0px) - 48px)',
          height: '48px',
          width: '48px',
          padding: '4px',
          boxSizing: 'border-box',
          justifyContent: 'center',
          alignItems: 'center',
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
